import { LOCALE_COOKIE_NAME, type SupportedLocale } from '@/i18n/config';

const COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365; // 1 year, rolling

/**
 * Client-side cookie writer for the locale toggle. Mirrors the server-side
 * cookie set by `middleware.ts` (1 year, `SameSite=Lax`, `HttpOnly=false`)
 * so the `getRequestConfig` resolver picks up the new value on the very next
 * navigation/refresh.
 */
export function writeLocaleCookie(locale: SupportedLocale): void {
  if (typeof document === 'undefined') return;
  const attrs = [
    `${LOCALE_COOKIE_NAME}=${encodeURIComponent(locale)}`,
    `max-age=${COOKIE_MAX_AGE_SECONDS}`,
    'path=/',
    'samesite=lax',
  ];
  document.cookie = attrs.join('; ');
}
